import { Component, h } from 'preact';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import FramesChild from './components/FramesChild';

// internal
import getJSON from './utils/get-json';
import {
  determineContestTitle,
  countdown,
  lastUpdatedFormat,
} from './election-utils';
import { RESULTS_IN_USE, visibleCandidatesCount } from './endpoints';
import { LENGTH_OF_CHECK_INTERVAL } from './constants';
import { PreactHTMLConverter } from 'preact-html-converter';

import context from '../../data/text.json';

const converter = PreactHTMLConverter();

class App extends Component<{ selectedContests: string[] }, {}> {
  constructor() {
    super();

    this.state = { contests: [] };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    const now = new Date();

    const selectedContests = this.props.selectedContests;

    const asOf = lastUpdatedFormat(now)

    getJSON(RESULTS_IN_USE).then(contests => {
      const activeContests = contests.filter(contest => {
        const slug = `${contest.office_slug}`;

        return selectedContests.indexOf(slug) >= 0;
      });

      this.setState({ contests: activeContests, asOf }, this.startTimer);
    });

    
  }

  startTimer() {
    this.timer = window.setTimeout(this.fetchData, LENGTH_OF_CHECK_INTERVAL);
  }

  clearTimer() {
    window.clearTimeout(this.timer);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  componentDidUpdate() {
                         // const length = Math.ceil(LENGTH_OF_CHECK_INTERVAL / 60000);
                         // countdown(length); //where n is the number of minutes required.
                       }

  render() {
    const { contests, asOf } = this.state;
    const { annotations, flags, embedType, embedDMN } = this.props;

    const isMoreText = context.status_of_race_embed == '' ? false : true;


    return (
      <FramesChild class="embed">
        {embedDMN != true && (
          <div class='embed-status-boxes'>
            <div class="status-current t-serif t-links-underlined">
              <div class="inner">
                <h3 class="t-copy t-copy--subheader">
                  Current status of election results
                </h3>

                <p class="t-copy">
                  {converter.convert(context.status_of_race[1].value[0])}
                </p>

                {isMoreText == true && (
                  <p class="t-copy" style="margin-top:1em;">
                    {converter.convert(context.status_of_race_embed[0].value)}
                  </p>
                )}
              </div>
            </div>

            <div class="t-links-underlined t-copy disclaimer-race-explain">
              <div class="inner">
                <h3 class="t-copy t-copy--subheader">
                  {converter.convert(
                  context.annotation_explain[0].value.text)}
                </h3>

                <div class="anno-text t-copy">
              
                <span class="dd_winner">✓</span>{' '}
                <span class="bullet_text">
                  
                  {converter.convert(
                    context.annotation_explain[1].value.called_races_bullet
                  )}
                </span>
              </div>
              
              <div class="anno-text t-copy">
                <svg class="icon anno-div note-icon" aria-hidden="true">
                                <use xlinkHref="#note-icon"></use>
                              </svg>{' '}
              {' '}
                <span class="bullet_text">
                  
                  {converter.convert(
                    context.annotation_explain[1].value.yellow_notes_bullet
                  )}
                </span>
              </div>

              <div class="anno-text t-copy">  
                <span class="gold-star">★</span>{' '}
                <span class="bullet_text">
                  {converter.convert(
                    context.annotation_explain[1].value.races_to_watch_bullet
                  )}
                </span>
              </div>

              <div class="anno-text t-copy">
                {converter.convert(
                  context.annotation_explain[1].value.pills_bullet
                )}    
              </div>
      
              <div class="anno-text t-copy">
                {converter.convert(
                  context.annotation_explain[1].value.embed_only_more_bullet
                )}
              </div>
            </div>
          </div></div>
        )}
        <div class="seat__races">
          {contests.map(contest => (
            <Contest
              key={contest.id}
              contest={contest}
              flags={embedDMN ? [] : flags.filter(item => item.type === contest.office_slug)}
              tableHeader={CandidateRow.Header}
              columnCount={CandidateRow.columnCount}
              contestTitle={determineContestTitle(contest, 'isPartner')}
              annotations={embedDMN ? [] : annotations.filter(item => item.type === contest.office_slug)}
              asOf={asOf}
              embedType={embedType}
              renderCandidate={(
                candidate,
                idx,
                viewAllCandidates,
                { totalVotes }
              ) => {
                return (
                  <CandidateRow
                    key={candidate.id}
                    ballotName={candidate.name}
                    candidateId={candidate.id}
                    isIncumbent={candidate.is_incumbent}
                    isWinner={candidate.is_winner}
                    isViewable={
                      viewAllCandidates || idx < visibleCandidatesCount
                    }
                    party={candidate.party}
                    totalVotesInContest={totalVotes}
                    votes={candidate.votes}
                  />
                );
              }}
            />
          ))}
        </div>
      </FramesChild>
    );
  }
}

export default App;
